<template>
  <div class="newsDetailContainer">
    <div class="mainContainer">
      <div class="headerTitle">
        <div v-preventReClick class="leftReturn" @click="hclose">
          <!--  <img src="" alt=""> -->
          <i class="el-icon-back" />
          <span>返回至首页</span>
        </div>
        <div class="titleMain">
          <!-- <span>许可证编号</span> -->
        </div>
        <div class="rightReturn" />
      </div>
      <!-- <div class="secondTitle">2021-12-16</div> -->
      <div class="imgContaienr">
        <img :src="zsimg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    zsimg: {
      type: String
    }
  },
  data() {
    return {
      title: '',
      content: '',
      picture: '',
      publishTime: '',
      contentAbstract: ''
    }
  },
  mounted() {},
  methods: {
    hclose() {
      // 跳转到首页
      this.$parent.XkzbhhcDetaiShow = false
      this.$parent.navtab1 = true
      this.$parent.navtab2 = false
      this.$parent.navtab3 = false
      this.$parent.navtab4 = false
      this.$parent.navtab5 = false
    }
  }
}
</script>

<style lang="less" scoped>
.newsDetailContainer {
  height: 100%;
  //height: calc(100% - 20px);
  overflow-y: auto;
  // overflow-x: hidden;
  // background-color: chocolate;
  box-shadow: 0 0 3px 1px #aaa;
  margin-bottom: 15px;
  .mainContainer {
    //width: 1226px;
    margin: 0 auto;
    padding-top: 40px;

    .headerTitle {
      display: flex;
      justify-content: space-between;
      .leftReturn {
        margin-left: 10px;
        width: 150px;
        height: 65px;
        //border: 3px solid #2878ff;
        border-radius: 2px;
        //margin-right: 100px;
        padding: 25px 0 10px 20px;
        display: flex;
        cursor: pointer;
        &:hover,
        &:active {
          color: #2878ff;
          // color: #fff;
        }
        i {
          font-size: 22px;
        }
      }
      .rightReturn {
        width: 150px;
        height: 65px;
      }
      .titleMain {
        margin-top: 18px;
        //width: 717px;
        height: 32px;
        font-size: 23px;
        font-family: "PingFangSC-Medium, PingFang SC";
        font-weight: 500;
        color: #434343;
        line-height: 32px;
      }
    }
    .secondTitle {
      margin: 0 auto;
      width: 138px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #434343;
      line-height: 20px;
      margin-top: 10px;
    }
    .imgContaienr {
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        margin: 30px auto;
      }
    }
    .contentMain {
      margin: 0 auto;
      width: 976px;
      height: 210px;
      font-size: 14px;
      font-family: "PingFangSC-Regular, PingFang SC";
      font-weight: 400;
      color: #434343;
      line-height: 30px;
      margin-bottom: 384px;
      text-indent: 28px;
    }
  }
}
</style>
